"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var TcpResult;

(function (TcpResult) {
  TcpResult[TcpResult["Success"] = 0] = "Success";
})(TcpResult = exports.TcpResult || (exports.TcpResult = {}));